import { render } from "./RecipeInterest.vue?vue&type=template&id=16ba4a9a&scoped=true"
import script from "./RecipeInterest.vue?vue&type=script&lang=js"
export * from "./RecipeInterest.vue?vue&type=script&lang=js"

import "./RecipeInterest.vue?vue&type=style&index=0&id=16ba4a9a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16ba4a9a"]])

export default __exports__